module.exports = __webpack_public_path__ + "img/fr.968aaa24.svg";